export default {
    paper: {
        backgroundColor: "white"
    }
};
